export default "__VITE_ASSET__62dc0ca3__"